var map = {
	"./book64.png": "./src/assets/imgs/mcollection/book64.png",
	"./bpjs64.png": "./src/assets/imgs/mcollection/bpjs64.png",
	"./cashier64.png": "./src/assets/imgs/mcollection/cashier64.png",
	"./credit_card.png": "./src/assets/imgs/mcollection/credit_card.png",
	"./fokus.png": "./src/assets/imgs/mcollection/fokus.png",
	"./histori.png": "./src/assets/imgs/mcollection/histori.png",
	"./installation.png": "./src/assets/imgs/mcollection/installation.png",
	"./insurance.png": "./src/assets/imgs/mcollection/insurance.png",
	"./invoice64.png": "./src/assets/imgs/mcollection/invoice64.png",
	"./iphone.png": "./src/assets/imgs/mcollection/iphone.png",
	"./logo.png": "./src/assets/imgs/mcollection/logo.png",
	"./logoindex.png": "./src/assets/imgs/mcollection/logoindex.png",
	"./pdam.png": "./src/assets/imgs/mcollection/pdam.png",
	"./pln.png": "./src/assets/imgs/mcollection/pln.png",
	"./repay64.png": "./src/assets/imgs/mcollection/repay64.png",
	"./saldo64.png": "./src/assets/imgs/mcollection/saldo64.png",
	"./setor64.png": "./src/assets/imgs/mcollection/setor64.png",
	"./tarik64.png": "./src/assets/imgs/mcollection/tarik64.png",
	"./telkom.png": "./src/assets/imgs/mcollection/telkom.png",
	"./ticket.png": "./src/assets/imgs/mcollection/ticket.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/mcollection sync recursive ^\\.\\/.*$";